module.exports = __webpack_public_path__ + "static/img/pop_up_header.756205f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/win_lose/pop_up_header.png
// module id = 57pt
// module chunks = 1